//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ArtistElements from '@motionelements/landing-pages/src/modules/artist/sections/ArtistElements.vue';
import HeroAside from '@motionelements/core/src/components/artist/sections/HeroAside.vue';

export default {
  name: 'artist-profile-page',
  props: {
    artist: {
      type: Object,
      required: true,
    },
    isArtistEditPage: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    HeroAside,
    PageMeta: () => import('@motionelements/core/src/components/ThePageMeta.vue'),
    ArtistPicks: () => import('@motionelements/landing-pages/src/modules/artist/sections/ArtistPicks.vue'),
    ArtistElements,
    ArtistFreeElements: () => import('@motionelements/landing-pages/src/modules/artist/sections/ArtistFreeElements.vue'),
    NuxtClientOnly: () => import('@motionelements/core/src/components/nav/NuxtClientOnly.vue'),
  },
  computed: {
    elementCounts() {
      return _.get(this.artist, 'elementCounts', [])
        .filter(({ mediaType, publishedCount }) => mediaType !== 'all' && publishedCount > 0);
    },
    artistData() {
      return {
        ...this.artist,
        elementCounts: this.elementCounts,
      };
    },
    artistPicks() {
      return _.get(this.artistData, 'picks', []);
    },
    artistUsername() {
      return _.get(this.artistData, 'username');
    },
    pageTitle() {
      return _.get(this.artist, 'html.title') || this.artistUsername;
    },
    pageDescription() {
      return _.get(this.artist, 'html.description');
    },
  },
};
